import { AccessLevelModel } from '../model/types';

export function getAccessLevelExplanationLabel(
  accessLevelModel: AccessLevelModel
): string {
  return `user_access_${accessLevelModel}_explanation`.toLocaleLowerCase();
}
